import { useState } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { usePost, usePut } from "../../actprep-ui/hooks/api";
import { apiUrls } from "../../actprep-ui/utils/urls";
import { showSuccessSnackbar } from "../../actprep-ui/utils/feedback";
import { useEffect } from "react";
import CreationFormWrapper from "../../actprep-ui/components/CreationFormWrapper";

export default function ProgramDayForm({
  open,
  setOpen,
  setValue,
  initialValue,
  initialDay,
}) {
  const editing = Boolean(initialDay);
  const createProgramDayMutation = usePost(apiUrls.admin.programDays());
  const editProgramDayMutation = usePut(apiUrls.admin.programDays());
  const [formData, setFormData] = useState({
    title: initialDay?.title || "",
    visible_title: initialDay?.visible_title || "",
  });
  const handleFocus = () => setError(null);
  const [error, setError] = useState(null);
  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    let response;
    if (editing) {
      response = await editProgramDayMutation.mutateAsync({
        ...formData,
        program_day_uuid: initialDay.uuid,
      });
    } else {
      response = await createProgramDayMutation.mutateAsync(formData);
    }
    const { data } = response;
    if (!data.success) {
      setError(data.reason);
      return;
    }
    setValue({
      uuid: data.program_day.uuid,
      label: data.program_day.__str__,
    });
    setOpen(false);
    if (editing) {
      showSuccessSnackbar("Program Day Updated!");
      return;
    }
    showSuccessSnackbar("New Program Day Created!");
  };

  useEffect(() => {
    if (open) {
      setFormData((formData) => ({
        ...formData,
        title: initialValue || initialDay?.title,
        visible_title: initialDay?.visible_title,
      }));
    }
  }, [open, initialValue, initialDay]);

  return (
    <CreationFormWrapper
      open={open}
      onClose={handleClose}
      onSubmit={onSubmit}
      error={error}
      title={
        editing
          ? `Editing '${initialDay.title}' Program Day`
          : "Add a new Program Day"
      }
      confirmText={editing ? "Save" : "Create"}
    >
      <Grid container gap={3} marginTop={1}>
        <Grid size={12}>
          <TextField
            fullWidth
            autoFocus
            required
            value={formData.title}
            onChange={(event) =>
              setFormData({
                ...formData,
                title: event.target.value,
              })
            }
            label="Title"
            type="text"
            variant="standard"
            onFocus={handleFocus}
          />
        </Grid>
        <Grid size={12}>
          <TextField
            fullWidth
            autoFocus
            value={formData.visible_title || ""}
            onChange={(event) =>
              setFormData({
                ...formData,
                visible_title: event.target.value,
              })
            }
            label="Student-Visible Title"
            type="text"
            variant="standard"
            onFocus={handleFocus}
          />
        </Grid>
      </Grid>
    </CreationFormWrapper>
  );
}
